
import { defineComponent } from 'vue';

type LocalData = {
  check: any;
  isFixed: boolean;
  lastScrollTop: number;
  scrollableElement: null | HTMLElement;
};

export default defineComponent({
  emits: ['change'],
  props: {
    threshold: {
      required: false,
      type: Number,
      default: 0,
    },
    bottomThreshold: {
      required: false,
      type: Number,
      default: -1,
    },
    headerClass: {
      required: false,
      type: String,
      default: 'vue-fixed-header',
    },
    fixedClass: {
      required: false,
      type: String,
      default: 'vue-fixed-header--isFixed',
    },
    hideScrollUp: {
      required: false,
      type: Boolean,
      default: false,
    },
    scrollableElementId: {
      type: String,
    },
  },

  data(): LocalData {
    return { check: null, isFixed: false, lastScrollTop: 0, scrollableElement: null as null | HTMLElement };
  },

  computed: {
    computedClass(): string {
      let className = this.headerClass;

      if (this.isFixed) {
        className = ' ' + this.fixedClass;
      }

      return className;
    },
  },

  mounted() {
    if (this.scrollableElementId) {
      this.scrollableElement = document.getElementById(this.scrollableElementId);
    }
    this.main();
    this.registerEvent();
  },
  beforeUnmount() {
    this.removeEvent();
  },

  methods: {
    getScrollTop() {
      if (this.scrollableElement) {
        return this.scrollableElement.scrollTop;
      }
      return window.pageYOffset || document.documentElement.scrollTop;
    },
    getScrollHeight() {
      if (this.scrollableElement) {
        return Math.max(this.scrollableElement.scrollHeight, this.scrollableElement.offsetHeight, this.scrollableElement.clientHeight);
      }
      const scrollHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight,
      );
      return scrollHeight;
    },
    main() {
      this.lastScrollTop = this.getScrollTop();

      this.check = () => {
        const { threshold, hideScrollUp, bottomThreshold } = this;
        const currentScrollPos = this.getScrollTop();
        const maxScrollHeight = this.getScrollHeight();
        const currentScrollPoint = window.scrollY + window.innerHeight;
        let isOverThreshold: boolean = currentScrollPos > threshold;
        const isScrollDown: boolean = currentScrollPos >= this.lastScrollTop;

        if (bottomThreshold > -1) {
          if (currentScrollPoint >= maxScrollHeight - bottomThreshold) {
            isOverThreshold = false;
          }
        }

        const newIsFixed: boolean = isScrollDown
          ? // down-scrolled - are we over threshold ?
            isOverThreshold
          : // up-scrolled - EITHER we don't care OR are we over threshold ?
          hideScrollUp
          ? false
          : isOverThreshold;

        this.lastScrollTop = currentScrollPos;

        if (this.isFixed !== newIsFixed) {
          this.isFixed = newIsFixed;
          this.$emit('change', this.isFixed);
        }
      };
    },
    registerEvent() {
      if (this.scrollableElement) {
        this.scrollableElement.addEventListener('scroll', this.check);
      } else {
        window.addEventListener('scroll', this.check);
      }
    },
    removeEvent() {
      if (this.scrollableElement) {
        this.scrollableElement.removeEventListener('scroll', this.check);
      } else {
        window.removeEventListener('scroll', this.check);
      }
    },
  },
});
